module.exports = "/img/_/_/_/assets/images/avatar/full_left/female//rogue.jpg?b19a0a4a764b9acddbc1910ca8a9dc45";